import { render, staticRenderFns } from "./AnswerQuestions.vue?vue&type=template&id=2d9ffa28&scoped=true"
import script from "./AnswerQuestions.vue?vue&type=script&lang=js"
export * from "./AnswerQuestions.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestions.vue?vue&type=style&index=0&id=2d9ffa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ffa28",
  null
  
)

export default component.exports